import { TherapistAction } from '../../../src/redux/actions/constant';

export const therapistAssignUndoAction = (payload: any) => {
  return {
    type: TherapistAction.THERAPIST_TASK_ASSIGN_UNDO_REQUEST,
    payload,
  };
};


export const therapistAssignUndoReset = () => {
  return {
    type: TherapistAction.THERAPIST_TASK_ASSIGN_UNDO_RESET,
  };
};
